import { Link, createFileRoute } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { useSession } from "@/hooks/use-session";
import { ConnectAccountSetup } from "@/components/fundraising/ConnectAccountSetup";

export const Route = createFileRoute("/_app/_/fundraising/setup")({
	component: FundraisingSetupPage,
});

function FundraisingSetupPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="p-6 text-muted-foreground">
				No campaign selected.
			</div>
		);
	}

	return (
		<div className="mx-auto max-w-3xl space-y-6 p-6">
			<div>
				<Link
					to="/fundraising/settings"
					className="mb-4 flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
				>
					<ChevronLeft className="h-4 w-4" />
					Fundraising Settings
				</Link>
				<h2 className="text-lg font-semibold">
					Connect Bank Account
				</h2>
				<p className="text-sm text-muted-foreground">
					Set up Stripe Connect to accept donations directly
				</p>
			</div>

			<div className="rounded-lg border bg-muted/40 p-4 text-sm text-muted-foreground space-y-1">
				<p className="font-medium text-foreground">What to expect</p>
				<p>
					You'll be redirected to Stripe's secure onboarding flow.
					Have your EIN, campaign bank account details, and a
					government-issued ID ready. Onboarding typically takes
					5–10 minutes.
				</p>
			</div>

			<ConnectAccountSetup campaignId={campaignId} />
		</div>
	);
}
